import { DisciplineType } from "public_app/events/entity";
var OfficialRole;
(function (OfficialRole) {
    OfficialRole[OfficialRole["Unknown"] = 0] = "Unknown";
    OfficialRole[OfficialRole["Adjudicator"] = 1] = "Adjudicator";
    OfficialRole[OfficialRole["Chairperson"] = 2] = "Chairperson";
    OfficialRole[OfficialRole["GeneralInvigilator"] = 3] = "GeneralInvigilator";
    OfficialRole[OfficialRole["Scrutineer"] = 4] = "Scrutineer";
    OfficialRole[OfficialRole["Moderator"] = 5] = "Moderator";
    OfficialRole[OfficialRole["SyllabusInvigilator"] = 6] = "SyllabusInvigilator";
})(OfficialRole || (OfficialRole = {}));
var getOfficialRoles = function () {
    return [
        { key: OfficialRole.Adjudicator, value: "Porotce" },
        { key: OfficialRole.Chairperson, value: "Vedoucí soutěže" },
        { key: OfficialRole.GeneralInvigilator, value: "Odborný dozor" },
        { key: OfficialRole.Moderator, value: "Moderátor" },
        { key: OfficialRole.Scrutineer, value: "Sčitatel" },
        { key: OfficialRole.SyllabusInvigilator, value: "Komisař katalogu figur" },
    ];
};
function getOfficialRoleName(val) {
    if (val == OfficialRole.Adjudicator) {
        return 'Porotce';
    }
    if (val == OfficialRole.Chairperson) {
        return 'Vedoucí soutěže';
    }
    if (val == OfficialRole.GeneralInvigilator) {
        return 'Odborný dozor';
    }
    if (val == OfficialRole.Scrutineer) {
        return 'Sčitatel';
    }
    if (val == OfficialRole.Moderator) {
        return 'Moderátor';
    }
    if (val == OfficialRole.SyllabusInvigilator) {
        return 'Komisař katalogu figur';
    }
    return '';
}
export function getAdjudicatorLicenceNaming(val) {
    if (val == "-D") {
        return 'III.';
    }
    if (val == "-B") {
        return 'II.';
    }
    if (val == "-A") {
        return 'I.A';
    }
    if (val == "-S") {
        return 'I.M';
    }
}
export function getOfficialLicenceNaming(val) {
    if (val == "-B") {
        return 'II.';
    }
    if (val == "-S") {
        return 'I.';
    }
}
export function getAdjudicatorLicenceKeys(fromHighest) {
    if (fromHighest === void 0) { fromHighest = false; }
    if (fromHighest) {
        return ["-S", "-A", "-B", "-D"];
    }
    return ["-D", "-B", "-A", "-S"];
}
export function getOfficialLicenseName(official, role, discipline) {
    if (discipline === void 0) { discipline = null; }
    if (role == OfficialRole.Adjudicator) {
        var filtered = official.licences.filter(function (i) { return i.discipline == discipline; });
        if (filtered.length) {
            return getAdjudicatorLicenceNaming(filtered[0].grade);
        }
    }
    else {
        var filtered = official.licences.filter(function (i) { return i.role == role; });
        if (filtered.length) {
            return getOfficialLicenceNaming(filtered[0].grade);
        }
    }
    return "";
}
export function getOfficialLicenseKey(official, role, discipline) {
    if (discipline === void 0) { discipline = null; }
    if (role == OfficialRole.Adjudicator) {
        var filtered = official.licences.filter(function (i) { return i.discipline == discipline; });
        if (filtered.length) {
            return filtered[0].grade;
        }
    }
    else {
        var filtered = official.licences.filter(function (i) { return i.discipline == discipline; });
        if (filtered.length) {
            return filtered[0].grade;
        }
    }
    return null;
}
export function getAdjudicatorLicensesString(official) {
    var stt = getOfficialLicenseName(official, OfficialRole.Adjudicator, 'Standard');
    var lat = getOfficialLicenseName(official, OfficialRole.Adjudicator, 'Latin');
    if (stt == lat) {
        return stt;
    }
    return stt + "/" + lat;
}
export function getOfficialLicenseStringByRole(official, role) {
    if (official !== undefined && official !== null) {
        if (role == OfficialRole.Adjudicator) {
            return getAdjudicatorLicensesString(official);
        }
        else {
            return getOfficialLicenseName(official, role);
        }
    }
}
var OfficialCompetitionAttendanceType;
(function (OfficialCompetitionAttendanceType) {
    OfficialCompetitionAttendanceType[OfficialCompetitionAttendanceType["Unknown"] = 0] = "Unknown";
    OfficialCompetitionAttendanceType[OfficialCompetitionAttendanceType["Initial"] = 1] = "Initial";
    OfficialCompetitionAttendanceType[OfficialCompetitionAttendanceType["CompetitionNational"] = 2] = "CompetitionNational";
    OfficialCompetitionAttendanceType[OfficialCompetitionAttendanceType["CompetitionForeign"] = 3] = "CompetitionForeign";
    OfficialCompetitionAttendanceType[OfficialCompetitionAttendanceType["Current"] = 4] = "Current";
    OfficialCompetitionAttendanceType[OfficialCompetitionAttendanceType["Reset"] = 5] = "Reset";
    OfficialCompetitionAttendanceType[OfficialCompetitionAttendanceType["Snapshot"] = 6] = "Snapshot";
})(OfficialCompetitionAttendanceType || (OfficialCompetitionAttendanceType = {}));
export var groupOfficialAttendancesByEventId = function (attendanceData) {
    var orderedAttendanceData = attendanceData.filter(function (p) { return true; });
    var allEventIds = orderedAttendanceData.map(function (p) { return p.eventId; });
    var uniqueEventIds = allEventIds.filter(function (c, i) { return allEventIds.indexOf(c) === i; });
    var groupedAttendanceData = uniqueEventIds.map(function (eventId) {
        var relatedCompetitions = orderedAttendanceData.filter(function (p) { return p.eventId === eventId; });
        var competitionsAdjudicatorStt = relatedCompetitions.filter(function (c) { return c.role === OfficialRole.Adjudicator && (c.discipline === DisciplineType.Standard || c.discipline === DisciplineType.Standard_Latin); });
        var competitionsAdjudicatorLat = relatedCompetitions.filter(function (c) { return c.role === OfficialRole.Adjudicator && (c.discipline === DisciplineType.Latin || c.discipline === DisciplineType.Standard_Latin); });
        var competitionsChair = relatedCompetitions.filter(function (c) { return c.role === OfficialRole.Chairperson; });
        var competitionsInvigilator = relatedCompetitions.filter(function (c) { return c.role === OfficialRole.GeneralInvigilator; });
        var competitionsScrutineer = relatedCompetitions.filter(function (c) { return c.role === OfficialRole.Scrutineer; });
        return {
            eventId: eventId,
            eventName: relatedCompetitions[0].eventName,
            date: relatedCompetitions[0].date,
            competitions: relatedCompetitions,
            competitionsAdjudicatorStt: competitionsAdjudicatorStt,
            competitionsAdjudicatorLat: competitionsAdjudicatorLat,
            competitionsChair: competitionsChair,
            competitionsInvigilator: competitionsInvigilator,
            competitionsScrutineer: competitionsScrutineer,
            numsAdjudicatorStt: {
                total: competitionsAdjudicatorStt.length,
                c1: competitionsAdjudicatorStt.filter(function (c) { return c.c1 > 0; }).length,
                c2: competitionsAdjudicatorStt.filter(function (c) { return c.c2 > 0; }).length,
                c3: competitionsAdjudicatorStt.filter(function (c) { return c.c3 > 0; }).length,
            },
            numsAdjudicatorLat: {
                total: competitionsAdjudicatorLat.length,
                c1: competitionsAdjudicatorLat.filter(function (c) { return c.c1 > 0; }).length,
                c2: competitionsAdjudicatorLat.filter(function (c) { return c.c2 > 0; }).length,
                c3: competitionsAdjudicatorLat.filter(function (c) { return c.c3 > 0; }).length,
            },
            numsChair: {
                total: competitionsChair.length,
                c1: competitionsChair.filter(function (c) { return c.c1 > 0; }).length,
                c2: competitionsChair.filter(function (c) { return c.c2 > 0; }).length,
                c3: competitionsChair.filter(function (c) { return c.c3 > 0; }).length,
            },
            numsInvigilator: {
                total: competitionsInvigilator.length,
                c1: competitionsInvigilator.filter(function (c) { return c.c1 > 0; }).length,
                c2: competitionsInvigilator.filter(function (c) { return c.c2 > 0; }).length,
                c3: competitionsInvigilator.filter(function (c) { return c.c3 > 0; }).length,
            },
            numsScrutineer: {
                total: competitionsScrutineer.length,
                c1: competitionsScrutineer.filter(function (c) { return c.c1 > 0; }).length,
                c2: competitionsScrutineer.filter(function (c) { return c.c2 > 0; }).length,
                c3: competitionsScrutineer.filter(function (c) { return c.c3 > 0; }).length,
            },
        };
    });
    return groupedAttendanceData;
};
export { OfficialRole, OfficialCompetitionAttendanceType, getOfficialRoleName, getOfficialRoles, };
